import { render, staticRenderFns } from "./registration-certificate-model.vue?vue&type=template&id=fb5cf74c&scoped=true"
import script from "./registration-certificate-model.vue?vue&type=script&lang=js"
export * from "./registration-certificate-model.vue?vue&type=script&lang=js"
import style0 from "./registration-certificate-model.vue?vue&type=style&index=0&id=fb5cf74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5cf74c",
  null
  
)

export default component.exports